module.exports = __webpack_public_path__ + "static/media/st-louis.2331a5f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/cities/st-louis.jpg
// module id = 535
// module chunks = 0